import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaInstagram } from 'react-icons/fa';
import { Reveal } from '../motion/Reveal';
import { trackEvent } from '../../utils/gtm';
import { storiesFor, storyUrl } from '../../data/lumiStories';

const LumiStoriesCarousel = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  const lng = (language || 'en').split('-')[0];
  const stories = storiesFor(lng);
  const scroller = useRef(null);
  const [missing, setMissing] = useState({});

  const scrollByCard = (dir) => {
    const el = scroller.current;
    if (!el) return;
    const card = el.querySelector('.lumi-story');
    const width = card ? card.getBoundingClientRect().width + 16 : 220;
    el.scrollBy({ left: dir * width, behavior: 'smooth' });
  };

  const onKeyDown = (event) => {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      scrollByCard(1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      scrollByCard(-1);
    }
  };

  return (
    <section className="home-odam-section lumi-stories" id="lumi-stories">
      <div className="container">
        <Reveal>
          <h2 className="home-odam-h2">{t('lumi.stories.title')}</h2>
        </Reveal>
        <Reveal delay={0.06}>
          <p className="home-odam-lead">{t('lumi.stories.subtitle')}</p>
        </Reveal>
        <div
          className="lumi-stories__region"
          role="region"
          aria-roledescription="carousel"
          aria-label={t('lumi.stories.title')}
          onKeyDown={onKeyDown}
        >
          <button type="button" className="lumi-stories__nav" onClick={() => scrollByCard(-1)} aria-label={t('home.testimonials.scroll.prev', 'Previous')}>
            ‹
          </button>
          <div className="lumi-stories__track" ref={scroller} tabIndex={0}>
            {stories.map((item) => {
              const title = t(`lumi.stories.items.${item.id}.title`, { defaultValue: item.id });
              const alt = t(`lumi.stories.items.${item.id}.alt`, { defaultValue: title });
              const showImage = item.cover && !missing[item.id];
              return (
                <a
                  key={item.code}
                  className="lumi-story"
                  href={storyUrl(item)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent('lumi_story_click', { story_id: item.id, language: lng }, lng)}
                >
                  <span className="lumi-story__frame">
                    {showImage ? (
                      <img
                        src={item.cover}
                        alt={alt}
                        width="540"
                        height="960"
                        loading="lazy"
                        decoding="async"
                        onError={() => setMissing((prev) => ({ ...prev, [item.id]: true }))}
                      />
                    ) : (
                      <span className="lumi-story__placeholder">
                        <img src="/assets/lumi/brand/lumi-mascot.webp" alt="" width="160" height="160" />
                        <span>{title}</span>
                      </span>
                    )}
                  </span>
                  <span className="lumi-story__title">{title}</span>
                  <span className="lumi-story__watch">
                    <FaInstagram aria-hidden="true" /> {t('lumi.stories.watch')}
                  </span>
                </a>
              );
            })}
          </div>
          <button type="button" className="lumi-stories__nav" onClick={() => scrollByCard(1)} aria-label={t('home.testimonials.scroll.next', 'Next')}>
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default LumiStoriesCarousel;
